module.exports = __webpack_public_path__ + "static/media/iphone.32cb4ade.svg";